module.exports = __webpack_public_path__ + "fonts/SEGOEPR.32442207.TTF";